export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14002.2212c8a2.jpg";